import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { BaseIcon } from '../../../components/base-icon.mjs';

const SvgPhoneHangup = forwardRef((props, ref) => /* @__PURE__ */ jsx(BaseIcon, { fill: "none", ref, ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.693 16.013H7.31a1.685 1.685 0 0 0 1.685-1.684v-.645A1.684 1.684 0 0 1 10.679 12h2.647a1.686 1.686 0 0 1 1.686 1.686v.646c0 .446.178.875.494 1.19.316.317.693.495 1.14.495h1.685a1.556 1.556 0 0 0 1.597-1.016c.078-.214.107-.776.088-1.002.014-4.415-3.571-6.003-8-6.004-4.427 0-8.014 1.585-8.01 5.996-.02.227.009.79.087 1.003a1.56 1.56 0 0 0 1.6 1.02Z"
  }
) }));

export { SvgPhoneHangup as default };
//# sourceMappingURL=phone-hangup.mjs.map
